module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/icon_1_image_x32-606f7.png";